import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { FormControl, SelectChangeEvent } from "@mui/material";
import { useAppDispatch } from "@/store/hooks";
import { addingDataElemAction, addingEndpointAction, addingEndpointEntryAction, addException } from "@/store/ses/sesItemConfigSlice";
import { addingRobotAction, addingRobotException } from "@/store/ses/sesRobotSlice";
import useTranslate from "@/hooks/useTranslate";
import {
	ACTION_BREAK,
	ACTION_CONFIRMATION,
	ACTION_DECLINE_DATA,
	ACTION_END,
	ACTION_EXTERNAL,
	ACTION_GO_TO,
	ACTION_QAS_ASK,
	ACTION_QAS_CHAT,
	ACTION_SAY,
	ACTION_SEND_FILE,
	ACTION_SET_REPORT,
	ACTION_SET_VARIABLE,
	ACTION_TRANSFER,
} from "@/constants/defaultValues";
import { ActionVariantType } from "@/types/ses/sesItemConfigTypes";
import { IconSelect } from "@/ui";
import { ACTION_ICONS, EXTENDED_ACTION_LIST } from "./FormAddingAction.const";
import { IFormAddingActionProps, TExtendedAction } from "./FormAddingAction.props";
import styles from "./FormAddingAction.module.scss";

const FormAddingAction = ({ channel, changeFlgHandler, actionFor }: IFormAddingActionProps): JSX.Element => {
	const [actionId, setActionId] = useState<string>(uuidv4()); // ID действия
	const [extendedSelectAction, _setExtendedSelectAction] = useState<TExtendedAction>("chooseAction"); // расширенный список действий

	const dispatch = useAppDispatch();

	const translate = useTranslate(); // hook для перевода текста

	const changeExtendedActions = (e: SelectChangeEvent<TExtendedAction>) => {
		const value = e.target.value as TExtendedAction;
		if (value === "say") addActionHandler({ ...ACTION_SAY, actionId });
		else if (value === "confirmation") addActionHandler({ ...ACTION_CONFIRMATION, actionId });
		else if (value === "sendfile") addActionHandler({ ...ACTION_SEND_FILE, actionId });
		else if (value === "setvariable") addActionHandler({ ...ACTION_SET_VARIABLE, actionId });
		else if (value === "goto") addActionHandler({ ...ACTION_GO_TO, actionId });
		else if (value === "setreport") addActionHandler({ ...ACTION_SET_REPORT, actionId });
		else if (value === "declinedata") addActionHandler({ ...ACTION_DECLINE_DATA, actionId });
		else if (value === "transfer") addActionHandler({ ...ACTION_TRANSFER, actionId });
		else if (value === "break") addActionHandler({ ...ACTION_BREAK, actionId });
		else if (value === "end") addActionHandler({ ...ACTION_END, actionId });
		else if (value === "external") addActionHandler({ ...ACTION_EXTERNAL, actionId });
		else if (value === "qas-ask") addActionHandler({ ...ACTION_QAS_ASK, actionId });
		else if (value === "qas-chat") addActionHandler({ ...ACTION_QAS_CHAT, actionId });
	};

	// обработчик добавления действия
	const addActionHandler = (actionObj: ActionVariantType): void => {
		setActionId(uuidv4()); // меняем ID

		if (actionFor.for === "robotException") {
			dispatch(addingRobotException({ exception: actionFor.exception, channel, action: actionObj })); // добавление исключения роботу в store
			changeFlgHandler("exceptions"); // ставим флаг о несохраненных данных
		} else if (actionFor.for === "dataException") {
			dispatch(addException({ targetObject: "dataElement", exception: actionFor.exception, channel, action: actionObj })); // добавление исключения ЭД в store
			changeFlgHandler("exceptions"); // ставим флаг о несохраненных данных
		} else if (actionFor.for === "endpointException") {
			dispatch(addException({ targetObject: "endpoint", exception: actionFor.exception, channel, action: actionObj })); // добавление исключения КТ в store
			changeFlgHandler("exceptions"); // ставим флаг о несохраненных данных
		} else if (actionFor.for === "endpointEntry") {
			dispatch(addingEndpointEntryAction({ channel, action: actionObj, withTimer: actionFor.withTimer })); // добавление действия входа КТ в store
			changeFlgHandler("entry"); // ставим флаг о несохраненных данных
		} else {
			actionFor.for === "robotEvent" && dispatch(addingRobotAction({ actionEvent: actionFor.event, channel, action: actionObj })); // добавление действия роботу в store
			actionFor.for === "dataElement" && dispatch(addingDataElemAction({ actionEvent: actionFor.event, channel, action: actionObj })); // добавление действия ЭД в store
			actionFor.for === "endpoint" && dispatch(addingEndpointAction({ channel, action: actionObj })); // добавление действия КТ в store
			changeFlgHandler("actions"); // ставим флаг о несохраненных данных
		}
	};

	return (
		<div className={styles.container}>
			{/* действие */}
			<FormControl margin="dense">
				<IconSelect<TExtendedAction>
					disabled={channel === ""}
					value={extendedSelectAction}
					onChange={changeExtendedActions}
					iconList={ACTION_ICONS}
					itemsList={EXTENDED_ACTION_LIST}
					haveHint={true}
					hintPrefix="hint_actionEvent"
					mode={extendedSelectAction === "chooseAction" ? "textOnInitial" : "fullIcon"}
					initialText={extendedSelectAction === "chooseAction" ? `${translate("button_addAction")}...` : ""}
				/>
			</FormControl>
		</div>
	);
};

export default FormAddingAction;
